const REGEX_CARACTERES_INVALIDOS = /[^a-zA-ZÀ-ÿ0-9\s.,;:!?()[\]{}"'`´~^°ªº\-_/\\+=*@#$%&\n\r]/gu;

const REGEX_ESPECIAIS_ESTRITO = /[^a-zA-ZÀ-ÿ0-9\s.,;:!?()'°ªº\-/]/gu;

const REGEX_FORA_DE_UM_NOME = /[^a-zA-ZÀ-ÿ\s.'-]/gu;

export function semCaracteresEspeciais(valor) {
  return String(valor ?? "").replace(REGEX_ESPECIAIS_ESTRITO, "");
}

export function temCaractereEspecial(texto) {
  const valor = String(texto ?? "");
  return semCaracteresEspeciais(valor) !== valor;
}

export function semNumerosNemEspeciais(valor) {
  return String(valor ?? "").replace(REGEX_FORA_DE_UM_NOME, "");
}

export function temNumeroOuCaractereEspecial(texto) {
  const valor = String(texto ?? "");
  return semNumerosNemEspeciais(valor) !== valor;
}

export default {
  install(Vue) {
    Vue.prototype.$goBack = function goBack() {
      this.$router.go(-1);
    };

    Vue.prototype.$somenteNumeros = function (valor) {
      return String(valor ?? "").replace(/\D/g, "");
    };

    Vue.prototype.$semEmojisNemEspeciais = function (valor) {
      return String(valor ?? "").replace(REGEX_CARACTERES_INVALIDOS, "");
    };

    Vue.prototype.$semCaracteresEspeciais = semCaracteresEspeciais;

    Vue.prototype.$temCaractereEspecial = temCaractereEspecial;

    Vue.prototype.$semNumerosNemEspeciais = semNumerosNemEspeciais;

    Vue.prototype.$temNumeroOuCaractereEspecial = temNumeroOuCaractereEspecial;

    Vue.prototype.$toggleItemPreenchidoBarraProgresso = function (
      item,
      shouldAdd,
      itemsPreenchidos = []
    ) {
      if (!Array.isArray(itemsPreenchidos)) {
        return shouldAdd ? [item] : [];
      }

      const index = itemsPreenchidos.indexOf(item);

      if (shouldAdd && index === -1) {
        itemsPreenchidos.push(item);
      } else if (!shouldAdd && index > -1) {
        itemsPreenchidos.splice(index, 1);
      }

      return itemsPreenchidos;
    };

    Vue.prototype.$checkTotallyFilled = function (
      isTotalFilled,
      propriedade = "totalmentePreenchido"
    ) {
      this[propriedade] = isTotalFilled;
      return isTotalFilled;
    };
  },
};
